<template>
  <v-card
    class="mx-auto rounded-lg"
    max-width="285"
    v-if="anuncio"
    style="border-radius: 1em;"
    elevation="2"
  >
    <v-img height="130" v-if="anuncio.imagens.length > 0" :src="anuncio.imagens[0]"/>
    <v-card
      v-else
      color="#DCDCDC"
      height="130"
      style="border-radius: 1em 1em 0em 0em;"
      elevation="0"
    >
      <v-layout justify-center align-center fill-height column>
          <v-icon color="gray" size="5em">image</v-icon>
      </v-layout>
    </v-card>
    <v-card-title primary-title>
      <h1 style="font-size: 1em;">{{ anuncio.titulo }}</h1>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-actions class="justify-space-around">
      <v-menu
        offset-y
        full-width
        lazy
      >
        <template v-slot:activator="{ on }">
          <v-btn icon dark v-on="on">
            <v-icon color="error">delete</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title
            class="
              justify-center
              error--text
            "
          >
            <h2>TEM CERTEZA QUE DESEJA DELETAR ESSE ANÚNCIO</h2>
          </v-card-title>
          <v-card-actions class="justify-space-around">
            <v-flex xs5>
              <v-btn block flat>
                Não
              </v-btn>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex xs5>
              <v-btn color="error" block flat @click="apagarAnuncios">
                SIM
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-divider vertical></v-divider>
      <v-tooltip bottom>
        <v-btn icon slot="activator" @click="ativarOuDesativarAnuncios">
          <v-icon :color="anuncio.ativo ? 'success' : 'error'">
            {{ anuncio.ativo ? 'check_circle' : 'close' }}
          </v-icon>
        </v-btn>
        <span>{{ anuncio.ativo ? 'Desativar Anúncio' : 'Ativar Anúncio' }}</span>
      </v-tooltip>
      <v-divider vertical></v-divider>
      <v-tooltip bottom>
        <v-btn icon slot="activator" @click="$emit('editar', anuncio)">
          <v-icon color="info">edit</v-icon>
        </v-btn>
        <span>Editar Anúncio</span>
      </v-tooltip>
      <v-divider vertical></v-divider>
      <v-tooltip bottom>
        <v-btn icon slot="activator" @click="$emit('visualizarAnuncio', anuncio)">
          <v-icon color="primary">visibility</v-icon>
        </v-btn>
        <span>Visualizar Anúncio</span>
      </v-tooltip>
    </v-card-actions>
    <!-- <v-dialog v-model="dialogDetalhes" v-if="dialogDetalhes" width="700" scrollable min-height="1000">
      <dialog-detalhes-da-anuncio @fechar="dialogDetalhes = false" :anuncio="anuncio"></dialog-detalhes-da-anuncio>
    </v-dialog> -->
  </v-card>
</template>

<script>
export default {
  components: {},
  props: ['anuncio'],
  data () {
    return {
      dialogDetalhes: false
    }
  },
  methods: {
    formatarTexto (texto) {
      const text = texto[0].toUpperCase() + texto.slice(1)
      return text
    },
    ativarOuDesativarAnuncios () {
      this.$store.dispatch('anuncios', {
        method: 'PUT',
        id: this.anuncio.id,
        body: {
          ...this.anuncio,
          ativo: !this.anuncio.ativo
        }
      }).then(() => {
        this.anuncio.ativo = !this.anuncio.ativo
        this.$emit('success', `O anúncio foi ${this.anuncio.ativo ? 'ativo' : 'desativo'} com sucesso.`)
        this.$emit('carregar')
      }).catch(() => {
        this.$emit('error', 'Não foi possível atualizar anúncio.')
      })
    },
    apagarAnuncios () {
      return this.$store.dispatch('anuncios', {
        method: 'DELETE',
        id: this.anuncio.id,
        body: this.anuncio
      }).then(() => {
        this.$emit('carregar')
      })
    }
  }
}
</script>
